<template>
	<v-dialog width="auto" v-model="dialog" @click:outside="close" class="text-center">
		<img class="chat-modal-image" @click="close" :src="imgUrl" alt="image" />
	</v-dialog>
</template>

<script>
export default {
	props: {
		imgUrl: {
			type: String,
			default: null,
		},
		dialog: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		close() {
			this.$emit('update:dialog', false)
		},
	},
}
</script>

<style>
.chat-modal-image {
	width: 100%;
	display: flex;
}
</style>
